// extracted by mini-css-extract-plugin
export default {"rowMenuItem":"row_menu-modules___rowMenuItem___e100f57a","icon":"row_menu-modules___icon___a443c3cd","label":"row_menu-modules___label___e5e29546"};